// !!!!
// This is a generated file.
// Do not manually change this file
// !!!!

export const Sale_Type = {
    Total_Free_Sample: 3670016,
    Taxable_Free_Sample: 3670017,
    Promotion: 3670018,
    Discount_on_Goods: 3670019,
    Normal: 3670020,
};
